import { Suspense, useCallback, useEffect, useRef, useState } from 'react'
import { Outlet } from 'react-router'
import { useTranslation } from 'react-i18next'
import { SignJWT } from 'jose'
import moment from 'moment'
import 'moment/locale/en-gb'
import 'moment/locale/id'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import 'react-spring-bottom-sheet/dist/style.css'

import { useStoreActions, useStoreState } from '@/stores'
import { UserProvider } from '@/routes/use_auth'
import { Container, Message } from '@/components'
import { getLocales, getSubscribeToken, setLocales } from '@/utils'
import { CLIENT_CODE } from '@/constants'

export const App = () => {
	const { i18n } = useTranslation()

	const profile = useStoreState(state => state.profile)

	const clientAction = useStoreActions(action => action.client)
	const client = useStoreState(state => state.client)

	const messageAction = useStoreActions(action => action.message)
	const message = useStoreState(state => state.message)

	const subscriptionAction = useStoreActions(action => action.subscription.auth)

	const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null)

	useEffect(() => {
		if (message.open) {
			if (timeoutRef.current) {
				clearTimeout(timeoutRef.current)
			}
			timeoutRef.current = setTimeout(() => {
				// messageActions.close()
			}, 5000)
		}
	}, [message.open])

	const getCurrentLanguage = useCallback(async () => {
		const lang = await getLocales()
		if (lang) {
			i18n
				.changeLanguage(lang)
				.then(() => {
					setLocales(lang)
				})
				.catch((err: string) => console.log(err))
		}
	}, [])

	useEffect(() => {
		getCurrentLanguage()
	}, [])

	useEffect(() => {
		clientAction.fetch()
	}, [])

	useEffect(() => {
		switch (i18n.language) {
			case 'en':
				moment.locale('en-gb')
				break
			case 'id':
			default:
				moment.locale('id')
				break
		}
	}, [i18n.language])

	const encryptJWT = async () => {
		const payload = {
			name: profile?.data?.name,
			phone_number: profile?.data?.phone?.mobile,
			email: profile?.data?.email,
			partner_code: CLIENT_CODE
		}
		const secretKey = 'secretCustomerApi'

		const encoder = new TextEncoder()
		const secret = encoder.encode(secretKey)

		const token = await new SignJWT(payload)
			.setProtectedHeader({ alg: 'HS256', typ: 'JWT' })
			.sign(secret)

		if (token) {
			subscriptionAction.login({
				partner_token: token
			})
		}
	}

	useEffect(() => {
		const loginSubscription = async () => {
			const token = await getSubscribeToken()
			if (token) {
				subscriptionAction.loggedIn(token)
			} else {
				if (profile.data) {
					encryptJWT()
				}
			}
		}
		loginSubscription()
	}, [profile.data])

	return (
		<Container>
			<UserProvider>
				<Suspense fallback={null}>
					<Outlet />
				</Suspense>
			</UserProvider>
			{message.open && (
				<Message
					type={message.type}
					message={message.message}
					onClose={() => messageAction.close()}
				/>
			)}
		</Container>
	)
}
